import styled from 'styled-components';

export const MenuWrapper = styled.div.withConfig({
  displayName: 'MenuWrapper',
  componentId: 'menu-wrapper',
})([
  `
    display: flex;
    flex-direction: column;
    margin-bottom: 32px;
    line-height: 120%;
        
    > h5, > h2, > div.menu-label {
        font-style: normal;
        font-weight: 530;
        font-size: 20px;
        margin: 0;
    }

    > div:not(.menu-label) {
        margin-right: 24px;
        margin-top: 16px;

        a {
            font-size: 18px;
            border-radius: 0;

            :hover {
                color: #2D91FF !important;
            }

            :focus-visible {
                outline: 3px solid #0071EE !important;
                outline-offset: 2px;
            }

            span {
                font-style: normal;
                font-weight: 520;
                padding: 2px 0;
                min-height: 24px;
                height: inherit;
                line-height: inherit;

                white-space: normal;
                text-wrap: balance;
                text-align: start;
            }
        }
    }

    @media screen and (min-width: 1281px) {
        position: fixed;
        width: 270px;
    }
`,
]);

export default MenuWrapper;
